import {
	TUTORIAL_DEMO_HEADER_BACK_SELECTOR,
	TUTORIAL_DEMO_HEADER_LOGO_SELECTOR,
} from '@/constants/professionalTutorialDemo';

export const COACH_SPOTLIGHT_PADDING_PX = 6;
export const COACH_SPOTLIGHT_RADIUS_PX = 6;
export const COACH_SPOTLIGHT_RING_CLASS =
	'pointer-events-none absolute rounded-md ring-2 ring-[rgb(27,235,185)]/50';

/** Observar back + logo para recalcular o buraco visual do header. */
export const TUTORIAL_DEMO_HEADER_LAYOUT_SELECTORS = [
	TUTORIAL_DEMO_HEADER_BACK_SELECTOR,
	TUTORIAL_DEMO_HEADER_LOGO_SELECTOR,
] as const;

export type CoachSpotlightRect = {
	top: number;
	left: number;
	width: number;
	height: number;
};

export const isVisibleCoachElement = (element: HTMLElement) => {
	const rect = element.getBoundingClientRect();
	if (rect.width < 1 || rect.height < 1) return false;

	let node: HTMLElement | null = element;
	while (node) {
		if (window.getComputedStyle(node).display === 'none') return false;
		node = node.parentElement;
	}

	return true;
};

export const toCoachSpotlightRect = (
	element: HTMLElement,
): CoachSpotlightRect => {
	const rect = element.getBoundingClientRect();

	return {
		top: rect.top - COACH_SPOTLIGHT_PADDING_PX,
		left: rect.left - COACH_SPOTLIGHT_PADDING_PX,
		width: rect.width + COACH_SPOTLIGHT_PADDING_PX * 2,
		height: rect.height + COACH_SPOTLIGHT_PADDING_PX * 2,
	};
};

const resolveVisibleHeaderElement = (selector: string) => {
	for (const element of document.querySelectorAll<HTMLElement>(selector)) {
		if (isVisibleCoachElement(element)) return element;
	}

	return null;
};

export const computeTutorialHeaderNavSpotlight =
	(): CoachSpotlightRect | null => {
		const backButton = resolveVisibleHeaderElement(
			TUTORIAL_DEMO_HEADER_BACK_SELECTOR,
		);
		const logo = resolveVisibleHeaderElement(
			TUTORIAL_DEMO_HEADER_LOGO_SELECTOR,
		);

		if (!backButton && !logo) return null;
		if (backButton && !logo) return toCoachSpotlightRect(backButton);
		if (!backButton && logo) return toCoachSpotlightRect(logo);

		const backRect = backButton!.getBoundingClientRect();
		const logoRect = logo!.getBoundingClientRect();
		const top =
			Math.min(backRect.top, logoRect.top) - COACH_SPOTLIGHT_PADDING_PX;
		const left =
			Math.min(backRect.left, logoRect.left) - COACH_SPOTLIGHT_PADDING_PX;
		const right =
			Math.max(backRect.right, logoRect.right) +
			COACH_SPOTLIGHT_PADDING_PX;
		const bottom =
			Math.max(backRect.bottom, logoRect.bottom) +
			COACH_SPOTLIGHT_PADDING_PX;

		return {
			top,
			left,
			width: right - left,
			height: bottom - top,
		};
	};

export const isTutorialHeaderBackInteractionTarget = (node: Node) => {
	for (const element of document.querySelectorAll<HTMLElement>(
		TUTORIAL_DEMO_HEADER_BACK_SELECTOR,
	)) {
		if (element.contains(node)) return true;
	}

	return false;
};

export const isTutorialHeaderInteractionTarget =
	isTutorialHeaderBackInteractionTarget;
